import React from 'react'
import PropTypes from 'prop-types'

import { offersAccountsAdapter, getNamedVariables } from 'components/offers/adapters/singleAccountAdapter';
import { POE_KEYS } from '../Step1ContractSavings/constants/poeKeys';

import { i18n } from 'core/i18n'

const { FormattedTextWithNamedVariables } = i18n;

const Step1OutsideSavingsFooter = (props) => {
    const { contractWizard } = props;
    const mainAccount = contractWizard.get('mainAccount').toJS();

    const { data: { accountDefinition = {}, accountConfig = {} } = {} } = mainAccount

    const accountData = offersAccountsAdapter(mainAccount.data);

    const getStaticRepresentativeExample = React.useCallback(() => {
        const { examples } = POE_KEYS[accountDefinition.accountType]
        return examples.map((example, index) => {
            const exampleNamedValues = getNamedVariables(example, { ...accountConfig, superIndex: index + 1  })
            return (
                <li key={example}>
                    <FormattedTextWithNamedVariables value={example} namedVariables={exampleNamedValues} />
                </li>
            )
        })
    }, [mainAccount])

    return (
        <ul className="step1ContractSavings__outsidefooter">
            {accountDefinition.accountType && getStaticRepresentativeExample()}
            {
                accountData.REPRESENTATIVE_EXAMPLE.map((example, index) => <li key={index}>{example}</li>)
            }
        </ul>
    )
}

Step1OutsideSavingsFooter.propTypes = {
    contractWizard: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
};

module.exports = Step1OutsideSavingsFooter;
